import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import Link from '../Link';
import styles from './LinkButton.module.scss';

/**
 * Extends the Link component using button styling.
 */
export default function LinkButton({
  color,
  variant,
  className,
  children,
  LinkComponent,
  ...otherProps
}) {
  return (
    <LinkComponent
      className={classnames(
        styles.link,
        styles[color],
        styles[variant],
        className,
      )}
      {...otherProps}
    >
      {children}
    </LinkComponent>
  );
}

LinkButton.propTypes = {
  /**
   * Visible content of Link.
   */
  children: PropTypes.node,
  /**
   * Name of CSS class to apply to content.
   */
  className: PropTypes.string,
  /**
   * Button colors for emphasis
   */
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'tertiary',
    'transparent',
  ]),
  /**
   * Button-style link size/layout variants
   */
  variant: PropTypes.oneOf(['default', 'small']),
  LinkComponent: PropTypes.elementType,
};

LinkButton.defaultProps = {
  color: 'default',
  variant: 'default',
  className: '',
  children: undefined,
  LinkComponent: Link,
};

LinkButton.displayName = 'LinkButton';
